module.exports = __webpack_public_path__ + "media/recipes/68-33dae66e.png";